import React from "react";

const Index = () => {
  return (
    <svg viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Group 47352">
        <circle id="Ellipse 1451" cx="19" cy="19" r="19" fill="white" />
        <path
          id="Vector"
          d="M27.2451 10.6583C25.6003 9.87343 23.8603 9.31575 22.071 9C21.8481 9.41095 21.5877 9.96368 21.4081 10.4034C19.4789 10.1076 17.5675 10.1076 15.6737 10.4034C15.4942 9.96378 15.228 9.41095 15.003 9C13.212 9.3159 11.4704 9.87499 9.82489 10.6624C6.55038 15.709 5.66269 20.6301 6.10649 25.4815C8.27835 27.1356 10.3831 28.1405 12.4524 28.798C12.9667 28.0767 13.4213 27.3131 13.8115 26.5151C13.0686 26.2266 12.3523 25.8711 11.6713 25.4528C11.8505 25.3173 12.0255 25.1761 12.196 25.0294C16.3227 26.9979 20.8065 26.9979 24.884 25.0294C25.0552 25.1751 25.2301 25.3163 25.4086 25.4528C24.7265 25.8722 24.0089 26.2284 23.2644 26.5171C23.6569 27.3185 24.1107 28.0828 24.6236 28.8C26.6948 28.1426 28.8015 27.1377 30.9734 25.4815C31.4942 19.8575 30.0838 14.9816 27.2451 10.6583ZM14.3738 22.498C13.135 22.498 12.119 21.3185 12.119 19.8822C12.119 18.4459 13.1133 17.2644 14.3738 17.2644C15.6343 17.2644 16.6502 18.4438 16.6285 19.8822C16.6305 21.3185 15.6343 22.498 14.3738 22.498ZM22.7061 22.498C21.4673 22.498 20.4515 21.3185 20.4515 19.8822C20.4515 18.4459 21.4456 17.2644 22.7061 17.2644C23.9667 17.2644 24.9825 18.4438 24.9609 19.8822C24.9609 21.3185 23.9667 22.498 22.7061 22.498Z"
          fill="#008060"
        />
      </g>
    </svg>
  );
};

export default Index;
